import React from 'react';
import { motion } from 'framer-motion';
import { Info, Target } from 'lucide-react';
import { dashboardData } from './data';
export function TeamGoalProgress() {
  const {
    kpis,
    teamGoalDetails
  } = dashboardData;
  return <div className="bg-white rounded-2xl shadow-sm border border-slate-200 overflow-hidden" data-id="element-334">
      <div className="px-6 py-5 border-b border-slate-200 flex items-center gap-3 bg-white" data-id="element-335">
        <div className="w-9 h-9 rounded-lg bg-blue-50 text-blue-600 flex items-center justify-center shrink-0" data-id="element-336">
          <Target size={20} data-id="element-337" />
        </div>
        <div data-id="element-338">
          <h2 className="text-base font-bold text-[#0a1e5e] uppercase tracking-wide" data-id="element-339">
            Team Goal Progress
          </h2>
          <p className="text-xs text-slate-500 mt-0.5" data-id="element-340">
            Where the team stands this month
          </p>
        </div>
      </div>

      <div className="p-6" data-id="element-341">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8" data-id="element-342">
          {/* Left Side: Calculation */}
          <div className="lg:col-span-4" data-id="element-343">
            <div className="bg-slate-50 rounded-xl p-6 border border-slate-200 h-full flex items-center justify-center" data-id="element-344">
              <div className="flex items-center gap-3" data-id="element-345">
                <div className="text-center" data-id="element-346">
                  <p className="text-xs font-bold text-slate-500 uppercase mb-2" data-id="element-347">
                    LOs on Team
                  </p>
                  <p className="text-4xl font-black text-[#0a1e5e]" data-id="element-348">
                    {teamGoalDetails.losOnTeam}
                  </p>
                  <p className="text-xs font-bold text-slate-400 mt-1" data-id="element-349">LOs</p>
                </div>
                <div className="text-2xl font-black text-slate-300 self-center pb-6" data-id="element-350">
                  ×
                </div>
                <div className="text-center" data-id="element-351">
                  <p className="text-xs font-bold text-slate-500 uppercase mb-2" data-id="element-352">
                    Goal Per LO
                  </p>
                  <p className="text-4xl font-black text-[#0a1e5e]" data-id="element-353">
                    {teamGoalDetails.goalPerLo.toLocaleString()}
                  </p>
                  <p className="text-xs font-bold text-slate-400 mt-1" data-id="element-354">
                    POINTS
                  </p>
                </div>
                <div className="text-2xl font-black text-slate-300 self-center pb-6" data-id="element-355">
                  =
                </div>
                <div className="text-center" data-id="element-356">
                  <p className="text-xs font-bold text-blue-600 uppercase mb-2" data-id="element-357">
                    Team Goal
                  </p>
                  <p className="text-4xl font-black text-blue-600" data-id="element-358">
                    {kpis.teamGoal.toLocaleString()}
                  </p>
                  <p className="text-xs font-bold text-blue-400 mt-1" data-id="element-359">POINTS</p>
                </div>
              </div>
            </div>
            <p className="text-xs font-bold text-slate-400 text-center mt-3" data-id="element-360">
              ({teamGoalDetails.newLosNotCounted} NEW — NOT COUNTED)
            </p>
          </div>

          {/* Right Side: Progress */}
          <div className="lg:col-span-8 flex flex-col" data-id="element-361">
            <div className="mb-6" data-id="element-362">
              <p className="text-sm font-bold text-slate-500 uppercase mb-2" data-id="element-363">
                Total Points (Month to Date)
              </p>
              <div className="flex items-baseline gap-2" data-id="element-364">
                <span className="text-6xl font-black text-[#0a1e5e] tracking-tighter" data-id="element-365">
                  {kpis.totalPointsMtd.toLocaleString()}
                </span>
                <span className="text-sm font-bold text-slate-400" data-id="element-366">POINTS</span>
              </div>
            </div>

            <div className="mb-6" data-id="element-367">
              <div className="flex justify-between text-xs font-bold text-slate-500 mb-2 uppercase" data-id="element-368">
                <span data-id="element-369">Progress to Goal</span>
                <span className="text-green-600" data-id="element-370">
                  {kpis.percentOfGoal.toFixed(1)}%
                </span>
              </div>
              <div className="w-full h-4 bg-slate-100 rounded-full overflow-hidden border border-slate-200" data-id="element-371">
                <motion.div initial={{
                width: 0
              }} animate={{
                width: `${kpis.percentOfGoal}%`
              }} transition={{
                duration: 1,
                ease: 'easeOut'
              }} className="h-full bg-green-600 rounded-full" data-id="element-372" />
              </div>
            </div>

            <div className="grid grid-cols-3 gap-4" data-id="element-373">
              <div className="bg-slate-50 rounded-lg p-3 border border-slate-200" data-id="element-374">
                <p className="text-xs font-bold text-slate-500 uppercase mb-1" data-id="element-375">
                  Team Goal
                </p>
                <p className="text-lg font-black text-[#0a1e5e]" data-id="element-376">
                  {kpis.teamGoal.toLocaleString()}
                </p>
                <p className="text-[10px] text-slate-400 mt-0.5" data-id="element-377">POINTS</p>
              </div>
              <div className="bg-slate-50 rounded-lg p-3 border border-slate-200" data-id="element-378">
                <p className="text-xs font-bold text-slate-500 uppercase mb-1" data-id="element-379">
                  Remaining
                </p>
                <p className="text-lg font-black text-[#0a1e5e]" data-id="element-380">
                  {teamGoalDetails.remainingPoints.toLocaleString()}
                </p>
                <p className="text-[10px] text-slate-400 mt-0.5" data-id="element-381">POINTS</p>
              </div>
              <div className="bg-green-50 rounded-lg p-3 border border-green-200" data-id="element-382">
                <p className="text-xs font-bold text-green-700 uppercase mb-1" data-id="element-383">
                  % Completed
                </p>
                <p className="text-lg font-black text-green-600" data-id="element-384">
                  {kpis.percentOfGoal.toFixed(1)}%
                </p>
                <p className="text-[10px] text-green-600 mt-0.5" data-id="element-385">OF GOAL</p>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-6 bg-blue-50 border border-blue-200 rounded-xl p-4 flex items-start gap-3" data-id="element-386">
          <div className="w-6 h-6 rounded-full bg-blue-600 text-white flex items-center justify-center shrink-0" data-id="element-387">
            <Info size={14} data-id="element-388" />
          </div>
          <p className="text-sm text-blue-900 font-medium" data-id="element-389">
            New LOs will start to count next month towards your Team Leads
            Score.
          </p>
        </div>
      </div>
    </div>;
}